import { Component, OnInit} from '@angular/core';
import { PhoneContactComponent } from '../../components/phone-contact/phone-contact.component';
import { CommonModule } from '@angular/common';
import { FeatureFlagsService } from '../../services/feature-flags.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [PhoneContactComponent, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  showLogo = false;

  constructor(public featureFlagService: FeatureFlagsService) {}

  ngOnInit() {
    if (this.featureFlagService.isFFEqual('qs_phonenumber_ff', 'hide_phonenumber_version')) {
      this.showLogo = true;
    }
  }
}
